import useConsultantStatementYears from "@/services/admin-services/query/useConsultantStatementYears";
import useStatementYears from '@/services/consultant-services/query/useStatementYears';
import useConsultantStatement from "@/services/admin-services/query/useConsultantStatement";
import useStatement from "@/services/consultant-services/query/useStatement";

/**
 * Hook intermédiaire pour gérer les appels conditionnels aux hooks de statement
 * selon que l'utilisateur est admin ou consultant
 *
 * @param {boolean} isAdmin - Indique si l'utilisateur est admin
 * @param {string} year - L'année sélectionnée
 * @param {string} consultantId - L'ID du consultant (requis si isAdmin)
 * @returns {object} - { allYears, errorYear, yearStatement, yearStatementLoading, yearStatementError }
 */
const useStatementData = (isAdmin, year, consultantId = null) => {
    const shouldSkipAdminHooks = !isAdmin || !consultantId;
    const shouldSkipUserHooks = isAdmin;

    // Appel des hooks admin (désactivés si !isAdmin via skip)
    const { allYears: adminAllYears, errorYear: adminErrorYear, loading: adminYearsLoading } = useConsultantStatementYears(
        consultantId,
        shouldSkipAdminHooks
    );
    const { data: adminYearStatement, loading: adminLoading, error: adminError } = useConsultantStatement(
        year,
        consultantId,
        shouldSkipAdminHooks
    );

    // Appel des hooks consultant (désactivés si isAdmin via skip dans useQuery)
    const { allYears: userAllYears, errorYear: userErrorYear } = useStatementYears(shouldSkipUserHooks);
    const { data: userYearStatement, loading: userLoading, error: userError } = useStatement(year, shouldSkipUserHooks);

    return {
        // Années disponibles
        allYears: isAdmin ? adminAllYears : userAllYears,
        errorYear: isAdmin ? adminErrorYear : userErrorYear,

        // Statement de l'année
        yearStatement: isAdmin ? adminYearStatement : userYearStatement,
        yearStatementLoading: isAdmin ? adminLoading : userLoading,
        yearStatementError: isAdmin ? adminError : userError,
    };
};

export default useStatementData;
